/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TokenV2ReponseType } from './TokenV2ReponseType';
import {
    TokenV2ReponseTypeFromJSON,
    TokenV2ReponseTypeFromJSONTyped,
    TokenV2ReponseTypeToJSON,
    TokenV2ReponseTypeToJSONTyped,
} from './TokenV2ReponseType';
import type { ChallengeListInner } from './ChallengeListInner';
import {
    ChallengeListInnerFromJSON,
    ChallengeListInnerFromJSONTyped,
    ChallengeListInnerToJSON,
    ChallengeListInnerToJSONTyped,
} from './ChallengeListInner';

/**
 * 
 * @export
 * @interface TokenV2ResponseChallengeList
 */
export interface TokenV2ResponseChallengeList {
    /**
     * 
     * @type {TokenV2ReponseType}
     * @memberof TokenV2ResponseChallengeList
     */
    type: TokenV2ReponseType;
    /**
     * 
     * @type {Array<ChallengeListInner>}
     * @memberof TokenV2ResponseChallengeList
     */
    challenges: Array<ChallengeListInner>;
}



/**
 * Check if a given object implements the TokenV2ResponseChallengeList interface.
 */
export function instanceOfTokenV2ResponseChallengeList(value: object): value is TokenV2ResponseChallengeList {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('challenges' in value) || value['challenges'] === undefined) return false;
    return true;
}

export function TokenV2ResponseChallengeListFromJSON(json: any): TokenV2ResponseChallengeList {
    return TokenV2ResponseChallengeListFromJSONTyped(json, false);
}

export function TokenV2ResponseChallengeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2ResponseChallengeList {
    if (json == null) {
        return json;
    }
    return {
        
        'type': TokenV2ReponseTypeFromJSON(json['type']),
        'challenges': ((json['challenges'] as Array<any>).map(ChallengeListInnerFromJSON)),
    };
}

export function TokenV2ResponseChallengeListToJSON(json: any): TokenV2ResponseChallengeList {
    return TokenV2ResponseChallengeListToJSONTyped(json, false);
}

export function TokenV2ResponseChallengeListToJSONTyped(value?: TokenV2ResponseChallengeList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': TokenV2ReponseTypeToJSON(value['type']),
        'challenges': ((value['challenges'] as Array<any>).map(ChallengeListInnerToJSON)),
    };
}

